import { FC } from "react";
import { Alert, Box, Paper, Typography } from "@mui/material";
import useBasePath from "src/utils/hooks/useBasePath";
import __ from "src/utils/Translations";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import Title from "src/Pages/Company/Absences/Title/Title";
import {
  ExportType,
  ImportType,
} from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";
import ImportForm from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecordsImports/ImportForm";
import ExportForm from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecordsImports/ExportForm";

const AbsenceRecordsCalendarsImport: FC = () => {
  const basePath = useBasePath();

  return (
    <Box
      sx={{ position: "relative" }}
      data-testid="absence-records-calendars-import"
    >
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Kartoteki pracowników"),
            to: `${basePath}/absences/absence-records`,
          },
          {
            label: __("Eksport i import kalendarzy pracowników"),
          },
        ]}
      />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Title
          title={__("Eksport i import kalendarzy pracowników")}
          subtitle={__(
            "Eksport i zbiorcza aktualizacja kalendarzy pracowników organizacji."
          )}
        />
      </Box>
      <ExportForm exportType={ExportType.CALENDARS} hasYearsFilter />
      <ImportForm importType={ImportType.EMPLOYEE_CALENDAR_CONFIGURATION} />
    </Box>
  );
};

//

export default AbsenceRecordsCalendarsImport;
